var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpperGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 71,
    viewBox: "0 0 74 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:rgba(245,250,255,0.53);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324 -163)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -163)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324 -144)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -144)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324 -125)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -125)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-324 -106)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-269 -106)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(324 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(335 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(346 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(357 172)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 163)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(368 172)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperGrid);
export default __webpack_public_path__ + "static/media/upper_grid.c075306c92fd34f42600a1991e4b7adb.svg";
export { ForwardRef as ReactComponent };